import script from "./WorkOrdersByAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkOrdersByAsset.vue?vue&type=script&setup=true&lang=js"

import "./WorkOrdersByAsset.vue?vue&type=style&index=0&id=4f986830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f986830"]])

export default __exports__